import { TFunction } from 'i18next';

export type MetadataBadgeVariant = 'success' | 'danger' | 'secondary';

export interface BrandMentionStatus {
  variant: MetadataBadgeVariant;
  statusText: string;
  tooltipText: string;
}

export const getVerifiedBrandStatus = (
  isVerified: boolean | undefined,
  brandMentioned: boolean | null | undefined,
  firmName: string,
  t: TFunction
): BrandMentionStatus => {
  if (isVerified === true && brandMentioned === true) {
    return {
      variant: 'success',
      statusText: t('sourcesOwnBrandMentioned'),
      tooltipText: t('sourcesOwnBrandTooltipMentioned', { firmName }),
    };
  }

  if (isVerified === true) {
    return {
      variant: 'danger',
      statusText: t('sourcesOwnBrandNotMentioned'),
      tooltipText: t('sourcesOwnBrandTooltipNotMentioned', { firmName }),
    };
  }

  return {
    variant: 'secondary',
    statusText: t('sourcesOwnBrandNotChecked'),
    tooltipText: t('sourcesOwnBrandTooltipNotChecked'),
  };
};
